import React, {useState} from "react";
import {formatMinutes} from "@/utils/textFormatting";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";
import {User} from "@/types";
import Popover from "@/Components/Popover";
import PurchaseModal from "@/Pages/Dashboard/Purchase/PurchaseModal";
import CreditsUsageBreakdown from "@/Components/CreditsUsageBreakdown";
import InfoIcon from "@/Components/Icons/InfoIcon";

export type CreditsProps = {
    credits: number,
    prices: Record<string, number>,
    inline?: boolean,
    user: User
}

export default function Credits({credits, prices, inline, user}: CreditsProps) {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => setShowModal(false);
    return (
        <div>
            <PurchaseModal
                show={showModal}
                onClose={closeModal}
                prices={prices}
            />
            <h5 className="mb-4 text-xl font-bold text-gray-900 dark:text-gray-100">
                <span>Credits</span>
            </h5>

            <div className={`${inline ? 'md:flex md:flex-row justify-between' : ''}`}>
                <div>
                    <p className="text-sm mb-0 text-gray-600 dark:text-gray-400">
                        Processing time remaining
                    </p>
                    <div className="flex items-center mt-1">

                        <h4 className="text-sm xl:text-base font-bold text-gray-900 dark:text-gray-100">{formatMinutes(credits)}</h4>
                        {!user.is_trial && (
                            <Popover trigger="hover" placement="right" content={<CreditsUsageBreakdown hours={credits / 60} />}>
                                <button type="button" className="ml-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                                    <InfoIcon
                                        className="text-gray-300 dark:text-gray-600 cursor-pointer hover:text-blue-700 dark:hover:text-blue-400 !w-5 !h-5"/>
                                </button>
                            </Popover>
                        )}
                    </div>
                    {
                        user.is_trial && (
                            <Popover trigger="hover" content={<FreeTrialMessage/>}>
                                <span
                                    className="bg-yellow-100 dark:bg-yellow-900/60 text-yellow-800 dark:text-yellow-400 text-xs font-medium me-2 px-2.5 py-0.5 rounded">Free Trial</span>
                            </Popover>

                        )
                    }
                </div>
                <button type="button"
                        onClick={() => setShowModal(true)}
                        className={` text-sm lg:text-base py-1.5 px-3 inline-block text-center rounded leading-normal text-gray-800 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 border border-gray-100 dark:border-gray-700 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-600 hover:ring-0 hover:border-gray-200 dark:hover:border-gray-600 focus:bg-gray-200 dark:focus:bg-gray-600 focus:border-gray-200 dark:focus:border-gray-600 focus:outline-none focus:ring-0 mr-2 self-center ${!inline ? 'w-full mt-5' : 'mt-5 md:mt-0'}`}>
                    Purchase more
                </button>
            </div>
        </div>
    )
}

function FreeTrialMessage() {
    return (
        <div className="p-5 w-64">
            <h3 className="text-yellow-800 dark:text-yellow-400 font-semibold mb-4">Free Trial</h3>
            <p className="text-sm dark:text-gray-300">
                You can only extract one video at a time. Upgrade by purchasing credits, to extract multiple videos at
                once, and upload URLs.
            </p>
        </div>
    )
}
